import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-payments-privacy',
  imports: [RouterLink],
  templateUrl: './payments-privacy.component.html',
  styleUrl: './payments-privacy.component.scss',
})
export class PaymentsPrivacyComponent {}
